export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11634.1763b69d.jpg";